<template>
  <div class="container container-fluid">
    <div v-if="showComponentData" class="mt-3">
      <div class="row">
        <!-- NUMERO DE SINIESTRO -->
        <div v-if="isFieldVisible('sinester_number')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="sinester_number" class="form-label text-left">{{ getFieldDescription('sinester_number') }}</label>
            <input
              type="text"
              class="form-control"
              name="sinester_number"
              v-model="formData.sinester_number"
              required="required"
              maxlength="255"
              @input="() => emitFieldChanged('sinester_number')"
            />
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4"/>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'FormInsurancePolice',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const formData = ref({
      sinester_number: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (dataCompany.value && dataCompany.value.sinester_number);
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      emit('formDataChanged', formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
    };
  },
};
</script>
